<div class="whatsapp-section" #sectionElement>
  <app-container>
    <div class="whatsapp-section__grid">
      <!-- WhatsApp Banner -->
      <div class="whatsapp-section__whatsapp-banner">
        <div class="whatsapp-section__whatsapp-content">
          <!-- Left - Phone Image -->
          <div class="whatsapp-section__phone-container">
           
          </div>

          <!-- Right - Content -->
          <div class="whatsapp-section__text-content">
            <div class="whatsapp-section__text-wrapper">
              <p class="whatsapp-section__text">Súmate a nuestro WhatsApp <b class="no-break">+56 9 5812 3297</b> y lleva el control de tu Unipay</p>
              <!-- <p class="whatsapp-section__text whatsapp-section__text--bold">en tu celular, desde whatsapp.</p> -->
            </div>

            <a
              href="https://wa.me/56958123297"
              target="_blank"
              rel="noopener noreferrer"
              class="whatsapp-section__whatsapp-button"
            >
            <span>
              <b>Ir a Whatsapp</b>
            </span>
            </a>
          </div>
        </div>
      </div>

      <!-- FAQ Banner -->
      <div class="whatsapp-section__faq-banner" (click)="onFaqBannerClick()">
        <div class="whatsapp-section__faq-content">
          <div class="whatsapp-section__mascot-container">
            <img
                src="https://www.unipay.cl/api/descargaArchivo/web-perro-pregunta.png"
                alt="Mascota Unipay"
                class="whatsapp-section__faq-image"
              />
          </div>
          <div class="whatsapp-section__faq-text">
            <div class="whatsapp-section__faq-header">
              <h3 class="whatsapp-section__faq-title">¿Tienes dudas?</h3>
              <p class="whatsapp-section__faq-description">
                Revisa nuestras preguntas frecuentes
              </p>
            </div>

            <a routerLink="/preguntas-frecuentes" class="whatsapp-section__faq-link">
              <span class="whatsapp-section__button-content">
                Ver más
              </span>
            </a>
            <div class="whatsapp-section__mascot-container-mobile">
              <img
                src="https://www.unipay.cl/api/descargaArchivo/web-perro-pregunta.png"
                alt="Mascota Unipay"
                class="whatsapp-section__mascot-image-mobile"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-container>
</div>
